import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Box,
} from "@mui/material";

export default function Messages() {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/messages`
        );
        const data = await response.json();

        const formatted = data.map((msg) => ({
          name: msg.name,
          email: msg.email,
          number: msg.mobile,
          content: msg.message,
          date: msg.date?.slice(0, 10) || "N/A",
        }));

        setMessages(formatted);
      } catch (error) {
        console.error("Error fetching messages:", error);
      }
    };

    fetchMessages();
  }, []);

  return (
    <Container sx={{ py: 2, width: "100%" }}>
      <Typography
        variant="h3"
        fontWeight="bold"
        color="black"
        textAlign="center"
        gutterBottom
      >
        MESSAGES
      </Typography>
      <Box mt={10} />

      <Grid container spacing={3}>
        {messages.length === 0 ? (
          <Typography variant="body1" textAlign="center" width="100%">
            No messages found.
          </Typography>
        ) : (
          messages.map((msg, index) => (
            <Grid item xs={12} key={index}>
              <Card sx={{ boxShadow: 3, borderRadius: 2, maxWidth: "300px" }}>
                <CardContent>
                  <Typography variant="h6" color="primary" gutterBottom>
                    {msg.name}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    📧 {msg.email}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    📞 {msg.number}
                  </Typography>
                  <Typography variant="body1" sx={{ mt: 2 }}>
                    {msg.content}
                  </Typography>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    sx={{ display: "block", mt: 2 }}
                  >
                    🕒 {msg.date}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))
        )}
      </Grid>
    </Container>
  );
}
